import React from 'react';
import { MapPin } from 'lucide-react';
import './MapSection.css';

const MapSection = ({ settings }) => {
  return (
    <section className="map-section">
      <div className="map-container">
        <div className="map-header">
          <MapPin className="map-icon" size={32} />
          <h2 className="map-title">Encuéntranos</h2>
          <p className="map-description">
            {settings.address || 'Antonio Jacobo Vial 1788, Independencia, Santiago de Chile'}
          </p>
        </div>

        <div className="map-wrapper">
          <iframe
            src={settings.google_maps_embed || 'https://www.google.com/maps?q=Centro+Terapeutico+Crecer+Juntos+Antonio+Jacobo+Vial+1788+Independencia+Santiago+Chile&output=embed'}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación Centro Terapéutico Crecer Juntos"
          ></iframe>
        </div>

        <div className="map-cta">
          <a
            href={settings.google_maps_url || 'https://maps.app.goo.gl/tsakdimfTYaY4c2f7'}
            target="_blank"
            rel="noopener noreferrer"
            className="map-button"
          >
            <MapPin size={20} />
            <span>Abrir en Google Maps</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
